module.exports = __webpack_public_path__ + "static/assets/a0b130dbafdc7958b73d162239053173.mp3";